<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Excess Auto Claim</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <br />
      <b-table
        responsive
        show-empty
        ref="claimExcessTable"
        :items="getDataClaimExcess"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(submitted_datetime)="{ item }">
          <p class="mb-0">{{item.submitted_datetime}}</p>
        </template>
        <template v-slot:cell(ticket_no)="{ item }">
          <router-link
            :to="{name: 'cxDetailAutoClaim', params: {id: item.claim_id}}"
            class="text-decoration-none"
            v-b-tooltip.hover
            title="View Detail"
          ><p class="mb-0 text-primary"><b>{{item.ticket_no}}</b></p></router-link>
        </template>
        <template v-slot:cell(shipment_code)="{ item }">
          <p class="mb-0">{{item.shipment_code}}</p>
        </template>
        <template v-slot:cell(submitted_username)="{ item }">
          <p class="mb-0">{{item.submitted_username}}</p>
        </template>
        <template v-slot:cell(claim_amount)="{ item }">
          <p class="mb-0">{{item.claim_amount | rupiah}}</p>
        </template>
        <template v-slot:cell(food_safe_guarantee)="{ item }">
          <p class="mb-0">{{item.food_safe_guarantee ? 'Yes': 'No'}}</p>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row class="row">
            <div class="col-md-5">
              <b-button
                block
                variant="success"
                @click="approveClaimExcess(item.id)"
              >
                Approve
              </b-button>
            </div>
            <div class="col-md-5">
              <b-button
                block
                variant="danger"
                @click="rejectClaimExcess(item.id)"
              >
                Reject
              </b-button>
            </div>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination align="right" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </div>
    <claim-pin-verification
      :showModal="modalFormPINVerificationShow"
      @close-pin-verification="closePINVerification"
      @after-submit-pin-verification="afterSubmitPINVerification">
    </claim-pin-verification>
  </div>
</template>

<script>
import claimPinVerification from "../component/ClaimPINVerification.vue";
import { disbursementTimeGuard } from "@/mixin/disbursementTimeGuard";

export default {
  components: { claimPinVerification },
  mixins: [disbursementTimeGuard],
  data() {
    return {
      filter: "",
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      fields: [
        {
          key: "submitted_datetime",
          label: "Submitted Date",
          sortable: false,
          class: "text-left"
        },
        {
          key: "ticket_no",
          label: "Ticket No.",
          sortable: false,
          class: "text-left"
        },
        {
          key: "shipment_code",
          label: "AWB No.",
          sortable: false,
          class: "text-left"
        },
        {
          key: "submitted_username",
          label: "Agent Name",
          sortable: false,
          class: "text-left"
        },
        {
          key: "claim_amount",
          label: "Claim Amount",
          sortable: false,
          class: "text-left"
        },
        {
          key: "food_safe_guarantee",
          label: "JMA",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-left" }
      ],
      claim_excess_payments: [],
      claim_excess_reject_reason: [],
      modalFormPINVerificationShow: false,
      excessClaimId: "",
      pinVerificationFor: "approveClaimExcess",
    }
  },
  beforeCreate() {
    this.$store
      .dispatch("ClaimExcessModule/getClaimExcessRejectReason")
      .then((response) => {
        this.claim_excess_reject_reason = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    getDataClaimExcess(ctx, callback) {
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("ClaimExcessModule/getAllClaimExcessWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.claim_excess_payments = response.data.data.results || [];
          callback(this.claim_excess_payments);
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get payment limitations",
            showConfirmButton: false,
            timer: 1500,
          });
          callback([]);
        });
      return null;
    },
    closePINVerification() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
    },
    afterSubmitPINVerification() {
      switch(this.pinVerificationFor) {
        case "approveClaimExcess":
          this.submitApproveClaimExcess();
          break;
        case "rejectClaimExcess":
          this.submitRejectClaimExcess();
          break;
      }
    },
    async approveClaimExcess(id) {
      if (!(await this.checkDisbursementTime())) return;
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      this.pinVerificationFor = "approveClaimExcess"
      this.excessClaimId = id;
    },
    rejectClaimExcess(id) {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      this.pinVerificationFor = "rejectClaimExcess"
      this.excessClaimId = id
    },
    submitApproveClaimExcess() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      this.$swal({
        title: "Checking...",
        text: "Please wait",
        imageUrl: "/img/loader_3_dots.gif",
        imageHeight: 100,
        showConfirmButton: false,
        allowOutsideClick: false
      });
      this.$store
        .dispatch("ClaimExcessModule/postApproveClaimExcess", this.excessClaimId)
        .then((response) => {
          this.$swal({
            title: "Di bayarkan!",
            text: "Claim sudah dibayarkan",
            type: "success",
            showConfirmButton: false,
            timer: 1000,
          });
          this.$refs.claimExcessTable.refresh();
        })
        .catch((error) => {
          this.$swal(error.response.data.message || "Failed");
          console.log(error);
        });
    },
    submitRejectClaimExcess() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      let options = {};
      this.claim_excess_reject_reason.forEach((item, i) => options[item.id] = `${i + 1}. ${item.description}`);
      this.$swal({
        title: "Reject Claim?",
        text: "Select a reason before processing",
        input: 'select',
        inputOptions: options,
        inputPlaceholder: 'Pilih alasan',
        inputValue: '',
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        confirmButtonText: "Tolak",
        cancelButtonText: "<span style='color:#6051a2'> Batal </span>",
        onOpen: () => {
          this.$swal.getConfirmButton().setAttribute('disabled', 'disabled');
          const input = this.$swal.getInput();
          input.oninput = () => {
            this.$swal.getConfirmButton().removeAttribute('disabled');
          };
        },
      }).then((result) => {
        if (result.value) {
          const rejectReasonId = result.value;
          if (rejectReasonId == "65bb5c7b489da2264d5e3ee2") {
            this.$swal({
              title: "Please fill others reject value",
              type: "warning",
              input: 'text',
              showCancelButton: true,
              confirmButtonColor: "#6051a2",
              cancelButtonColor: "#f8f9fc",
              confirmButtonText: "Submit",
              cancelButtonText: "<span style='color:#6051a2'> Batal </span>",
              onOpen: () => {
                this.$swal.getConfirmButton().setAttribute('disabled', 'disabled');
                const input = this.$swal.getInput();
                input.oninput = () => {
                  this.$swal.getConfirmButton().removeAttribute('disabled');
                };
              },
            }).then((result) => {
              if (result.value) {
                const formData = new FormData();
                formData.append("reject_reason_id", rejectReasonId);
                formData.append("reject_reason_free_text", result.value);
                this.$store
                  .dispatch("ClaimExcessModule/postRejectClaimExcess", {
                    id: this.excessClaimId,
                    formData,
                  })
                  .then((response) => {
                    this.$swal({
                      text: "Claim sudah ditolak",
                      type: "success",
                      showConfirmButton: false,
                      timer: 1000,
                    });
                    this.$refs.claimExcessTable.refresh();
                  })
                  .catch((error) => {
                    this.$swal(error.response.data.message || "Failed");
                  });
              } else {
                this.$refs.claimExcessTable.refresh();
              }
            });
          } else {
            const formData = new FormData();
            formData.append("reject_reason_id", rejectReasonId);
            this.$store
              .dispatch("ClaimExcessModule/postRejectClaimExcess", {
                id: this.excessClaimId,
                formData,
              })
              .then((response) => {
                this.$swal({
                  text: "Claim sudah ditolak",
                  type: "success",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.$refs.claimExcessTable.refresh();
              })
              .catch((error) => {
                this.$swal(error.response.data.message || "Failed");
              });
          }
        } else {
          this.$refs.claimExcessTable.refresh();
        }
      });
    }
  }
};
</script>

<style scoped>
.btn-success {
  background-color: #29B473 !important;
  border-color: #29B473 !important;
}
</style>